<!-- 
工单评价
  props:
    id 详情页id
 -->

<template>
  <div class="evaluate">

    <div class="has-eva" v-if="hasContent">
      <div class="view-item">
        <div class="label">
          综合评价：
        </div>
        <div class="con" style="display:inline-block">
          <el-rate
            v-model="rate"
            disabled
            >
          </el-rate>
          
        </div>
        <span>
            ({{this.starRemark}})
          </span>
      </div>
      <div class="view-item">
        <div class="label">
          评价详情：
        </div>
        <div class="con">
          <p>{{content}}</p>
        </div>
      </div>
      <div class="view-item" v-if="evaluator">
        <div class="label">
          评价人：
        </div>
        <div class="con">
          <p>{{evaluator}}</p>
        </div>
      </div>
    </div>

    <div class="no-eva" v-else>
      <img src="../../../assets/imgs/empty.png" alt="">
      <p class="text" v-if="isFinished">工单尚未完成，暂时不能评价</p>
      <template v-else>
        <p class="text" v-if="isShowEvaluateButton">此工单暂无评价,可对工单进行评价</p>
        <p class="text" v-else>此工单暂无评价</p>
        <el-button  v-if="isShowEvaluateButton" type="warning" @click="handleEva">马上评价</el-button>
      </template>
    </div>

    <!-- 评价弹窗 -->
    <el-dialog title="工单评价" :visible.sync="dialogFormVisible" :modal-append-to-body="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="综合评价" prop="star">
          <el-rate
            class="form-rate"
            v-model="form.star"
            @change="handleStar"
            show-text
            :texts="form.starRemark"
            >
          </el-rate>
        </el-form-item>
        <el-form-item label="评价详情">
          <el-input v-model="form.content" type="textarea" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="validateForm">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'

export default {

  name: 'evaluate',

  props: {
    id: {
      type: Number
    }
  },

  data () {
    return {
      rate: 0,
      content: '',
      evaluator: '',
      starRemark: '', // 只读时显示的星级提示
      dialogFormVisible: false,
      form: {
        star: 0,
        content: '',
        starRemark: ['非常不满意', '不满意', '正常', '满意', '非常满意'] // 评价时显示的星级提示
      },
      rules: {
        star: { required: true, min: 1, max: 5, type: 'number', message: '请选择评价', trigger: 'change' }
      },
      hasContent: false,  //  是否有评论内容
      isShowEvaluateButton: false,   //  用户是否有权限评价
      isFinished: false // 工单完成状态
    }
  },

  mounted () {
    //  获取评价
    this.getEvaluate()
  },
  methods: {
    // 监听评价的改变，手动触发验证
    handleStar () {
      this.$refs.form.validateField('star')
    },

    // 触发评价
    handleEva () {
      this.dialogFormVisible = true
    },

    // 验证表单
    validateForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitEva()
        }
      })
    },

    // 提交评价
    submitEva () {
      const url = '/workOrder/evaluate.html'
      let params = {
        id: this.id,
        star: this.form.star,
        content: this.form.content,
        inside: 1
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功！'
        })
        //  操作成功之后，把提交的数据初始化为空 并且让弹框消失 重新获取一下评价的内容
        this.form.star = 0
        this.form.content = ''
        this.dialogFormVisible = false
        this.getEvaluate()
      })
    },

    //  处理获取到的评价内容的数据的方法
    getEvaluate () {
      let url = '/workOrder/getEvaluate.html'
      api.post(url, {id: this.id}, (data) => {
        //  获取工单评价并且做相应的处理
        this.disposeEvaluate(data)
      })
    },
    //  获取工单的数据，进行相应的操作
    disposeEvaluate (data) {
      if (data.hasContent === 1) {  //  评论存在的情况下
        this.hasContent = true
        this.rate = data.star
        this.content = data.content
        this.evaluator = data.evaluator
        switch (this.rate) {
          case 1: this.starRemark = '非常不满意'
            break
          case 2: this.starRemark = '不满意'
            break
          case 3: this.starRemark = '正常'
            break
          case 4: this.starRemark = '满意'
            break
          case 5: this.starRemark = '非常满意'
            break
        }
      } else {
        //  有评价权限
        if (data.evaluate === 1) {
          this.isShowEvaluateButton = true
        }

        // 工单已完成
        if (data.statusId === 2) {
          this.isFinished = true
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .evaluate {
    position: relative;
    .has-eva {
      padding-left: 50px;
      .view-item {
        margin-top: 40px;
        position: relative;
        padding-left: 72px;
        .label {
          position: absolute;
          font-size: 13px;
          left: 0;
          top: 0;
          line-height: 1.6;
        }
        .con {
          max-width: 400px;
          p {
            font-size: 13px;
            line-height: 1.6;
          }
        }
      }
    }
    .no-eva {
      text-align: center;
      margin-top: 100px;
      .text {
        font-size: 15px;
        margin-top: 30px;
        margin-bottom: 25px;
      }
    }
    .el-form {
      padding-right: 40px;
    }
    .form-rate {
      margin-top: 8px;
    }
  }
</style>


// WEBPACK FOOTER //
// evaluate.vue?d717934a